module.exports = __webpack_public_path__ + "static/media/vc.748ecabc.webp";